﻿import { ApiBase } from 'classes/ApiBase';
import { Student, Success } from 'types';

export class Api extends ApiBase {

    protected static baseUrl = '/Api/Resources';

    public static LookUpStudent(firstname: string, lastname: string, email: string): Promise<Student[]> {

	    return fetch('/Api/Students/LookUpStudent', {
	        body: JSON.stringify({
	            email: email,
	            firstName: firstname,
	            lastName: lastname
	        }),
	        headers: {
	            'Content-Type': 'application/json'
	        },
	        method: 'POST'
	    }).then(res => res.json());

    }

    public static MergeAccounts(keepId: number, mergeId: number): Promise<Success<any>[]> {

	    return fetch('/Api/Students/MergeAccounts', {
	        body: JSON.stringify({
	            accKeep: keepId,
	            accMerge: mergeId
	        }),
	        headers: {
	            'Content-Type': 'application/json'
	        },
	        method: 'UPDATE'
	    }).then(res => res.json()).catch(console.error);

    }

}
